<button
	type="button"
	class="tooth-button"
	[attr.data-testid]="'tooth-' + tooth.toothId"
	[attr.aria-pressed]="tooth.isSelected"
	[disabled]="chartReadOnly || isToothDisabled"
	(click)="onToothClick()"
	[attr.aria-label]="'TeethDiagram.ToothAlt' | translate:{ number: displayNumber }"
>
	<span *ngIf="numberPosition === 'above'" class="tooth-number">{{ displayNumber }}</span>
	<svg class="tooth-image" aria-hidden="true"><use [attr.href]="'#' + symbolId" /></svg>
	<span *ngIf="numberPosition === 'below'" class="tooth-number">{{ displayNumber }}</span>
</button>
<div class="tooth__selection-frame"></div>
